import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dim" }
const _hoisted_2 = {
  key: 0,
  class: "pop-up-mask-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "bundle" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = {
  key: 1,
  class: "pop-up-mask-container"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "bundlepdf" }
const _hoisted_9 = {
  key: 2,
  class: "pop-up-mask-editor-container"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "bundleText" }

import { onMounted, ref, computed, toRefs, watch } from 'vue';
import { getIcon } from '@/helpers/api';
import { modalController } from '@ionic/vue';
import { getFont, IFont } from '@/helpers/fonts';
import { useDeviceStatus } from '@/stores/deviceStatus';


export default /*@__PURE__*/_defineComponent({
  __name: 'PopUpMask',
  props: {
    showArrow: {
        type: Boolean,
        default: true
    },
    useEmitClose: {
        type: Boolean,
        default: false
    },
    showPdfContainer: {
        type: Boolean,
        default: false
    },
    isLarge: {
        type: Boolean,
        default: false,
    },
    showModalText: {
        type: Boolean,
        default: false
    },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { isWeb } = toRefs(useDeviceStatus())
const arrow_left = ref<string>()
const x_icon = ref<string>()

const emit = __emit;

const props = __props

onMounted(async () => {
    arrow_left.value = await getIcon("1010", "left_arrow");
    x_icon.value = await getIcon("1010", "close");
})

function close() {
    if (props.useEmitClose) {
        emit('close');
    } else {
        return modalController.dismiss(null, 'cancel');
    }
}

const nobo30 = ref<IFont | undefined>()
const nore14 = ref<IFont | undefined>()

onMounted(async () => {
    nobo30.value = await getFont('nobo30')
    nore14.value = await getFont('nore14')
})

const titleFont = computed(() => {
    return {
        '--title-font-family': nobo30.value?.['font-family'],
        '--title-font-size': nobo30.value?.['font-size'],
        '--title-font-transform': nobo30.value?.['text-transform'],
        '--title-font-weight': nobo30.value?.['font-weight'],
        'text-wrap': 'pretty'
    }
})
const descriptionFont = computed(() => {
    return {
        '--description-font-family': nore14.value?.['font-family'],
        '--description-font-size': nore14.value?.['font-size'],
        '--description-font-transform': nore14.value?.['text-transform'],
        '--description-font-weight': nore14.value?.['font-weight'],
        'text-wrap': 'pretty'
    }
})

const getCloseIcon = computed(() => isWeb.value ? x_icon.value : arrow_left.value)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fullpage", { large: __props.isLarge }]),
    style: _normalizeStyle({ ...titleFont.value, ...descriptionFont.value })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.showPdfContainer && !__props.showModalText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.showArrow)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: getCloseIcon.value,
                  id: "arrow-back",
                  onClick: close
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "icon")
              ]),
              _renderSlot(_ctx.$slots, "title"),
              _renderSlot(_ctx.$slots, "description")
            ]),
            _renderSlot(_ctx.$slots, "button")
          ]))
        : _createCommentVNode("", true),
      (__props.showPdfContainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (__props.showArrow)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: getCloseIcon.value,
                  id: "arrow-back",
                  onClick: close
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "pdfContainer")
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.showModalText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (__props.showArrow)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: getCloseIcon.value,
                  id: "arrow-back",
                  onClick: close
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _renderSlot(_ctx.$slots, "textContainer")
            ]),
            _renderSlot(_ctx.$slots, "button")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 6))
}
}

})